import { faDesktop, faHashtag, faListUl } from '@fortawesome/free-solid-svg-icons';

// How children start an activity. Mirrors yuha-functions src/selfStart/startCodeService.js.
export const SELF_START_METHODS = [
  { value: 'portal', icon: faDesktop, label: 'Alleen starten vanuit portaal', help: 'Een begeleider start de activiteit vanuit het portaal.' },
  { value: 'code', icon: faHashtag, label: 'Vanuit bril starten met unieke code', help: 'Spelers starten zelf een activiteit met hun startcode.' },
  { value: 'name', icon: faListUl, label: 'Vanuit bril starten met naam keuze uit lijst', help: 'Spelers kiezen hun naam uit de lijst van de groep op de bril.' },
];

const METHOD_VALUES = SELF_START_METHODS.map((method) => method.value);

export function selfStartMethod(value) {
  return SELF_START_METHODS.find((method) => method.value === value) || null;
}

export function selfStartMethodLabel(value) {
  return selfStartMethod(value)?.label || '';
}

// Schools from before selfStartMethod only have the selfStart boolean (= code)
export function schoolSelfStartMethod(school = {}) {
  if (METHOD_VALUES.includes(school.selfStartMethod)) return school.selfStartMethod;
  return school.selfStart ? 'code' : 'portal';
}

// Device override: 'inherit' or a method; legacy 'on'/'off' map to 'code'/'portal'
export function normalizeDeviceSelfStartMode(mode) {
  if (mode === 'on') return 'code';
  if (mode === 'off') return 'portal';
  return METHOD_VALUES.includes(mode) ? mode : 'inherit';
}

export function resolveDeviceSelfStartMethod(schoolMethod, deviceMode) {
  const mode = normalizeDeviceSelfStartMode(deviceMode);
  return mode === 'inherit' ? schoolMethod : mode;
}
